import script from "./onceImgScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./onceImgScreen.vue?vue&type=script&setup=true&lang=js"

import "./onceImgScreen.vue?vue&type=style&index=0&id=cdd49caa&lang=less"

const __exports__ = script;

export default __exports__